import {
	Integration,
	IntegrationFeatureOauth,
	IntegrationProviderId,
	IntegrationStatus,
	OauthScope,
	SettingsConfig,
	SettingsConfigType,
} from "../../../../index";

const googleIntegration = new Integration({
  id: "google",
  name: "Google integration",
  description:
    "Google is a file hosting service that offers cloud storage, file synchronization, personal cloud, and client software.",
  providerId: IntegrationProviderId.GOOGLE,
  status: IntegrationStatus.ACTIVE,
  docsUrl: "",
	features: [
		new IntegrationFeatureOauth({
			id: "oauth",
			scopes: [
				new OauthScope({
					id: "userinfo",
					name: "User Info",
					description: "View your basic profile info",
					required: true,
					key: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
					usedByAddOns: [],
				}),
				new OauthScope({
					id: "drive_allowed_files",
					name: "Drive Allowed Files",
					description: "View files and folders from a list of allowed files and folders in Google Drive that you give access to.",
					required: false,
					key: "https://www.googleapis.com/auth/drive.file",
					usedByAddOns: [],
				}),
			],
		}),
	],
  settingsConfig: [
		new SettingsConfig({
      id: "display_name",
      label: "Integration name",
      description:
        "The name of the integration that will be displayed in the integrations list",
      type: SettingsConfigType.STRING,
      required: true,
      editable: true,
      encrypted: false,
    }),
    new SettingsConfig({
      id: "oauth",
      label: "Select access scopes",
      type: SettingsConfigType.OAUTH,
			description: "Select the access scopes you want to give to the integration, we recommend giving only the scopes that are necessary for the integration to work. This can be changed later.",
      required: true,
      editable: true,
    }),
	],
});

export default googleIntegration;
